import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const helpCenterSettingsFormsRoute: InvariantJiraRoute = {
	exact: true,
	name: 'helpcenter-settings-forms',
	path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/forms',
};
